<template lang="html">
  <section v-if="visible" v-on:click="onSelected">
    <div class="m-list-option">
      <div
        class="slds-icon_container m-list-option-icon"
        :class="getIconClass(listItem)"
      >
        <svg class="slds-icon">
          <use :xlink:href="iconPath"></use>
        </svg>
      </div>
      <div class="m-text-items">
        <div class="m-ellipsis" v-html="name"></div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import { highlight } from "@/components/utils/highlight";
  import utils from "@/utils";
  export default  {
    name: 'search-box-icon-item',
    props: {
      listItem: {
        type: Object
      },
      exp: {
        type: String
      }
    },
    mounted() {
      this.name = this.listItem.name;
      if(!this.name) {
        this.visible = false;
      }
    },
    watch: {
      exp: function() {
        this.updateDisplay();
      }
    },
    data () {
      return {
        name: "",
        city: "",
        visible: true
      }
    },
    computed: {
      iconPath() {
        return utils.getIconPath(this.listItem);
      }
    },
    methods: {
      getIconClass(item) {
        return utils.getIconClass(item);
      },
      onSelected() {
        /**
         * Triggers when item is selected
         */
        const EVENT = "on-search-box-item-selected";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, this.listItem);
        }
      },
      updateDisplay() {
        this.visible = true;
        if(!this.exp) {
          this.name = this.listItem.name;
        } else {
          this.name = highlight.find(this.listItem.name, this.exp);
          if(this.name === this.listItem.name) {
            this.visible = false;
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .m-list-option-icon {
    margin: 0 0.5rem;
  }

  .m-list-option {
    display: flex;
    padding: 2px 0;
    align-items: center;
  }
  .m-text-items {
    overflow: hidden;
  }
</style>
